import { useSelector } from "react-redux";
import { USER_SERVICES_LABELS } from "constants/Labels/usersListLabels";

export const useArquivaMix = () => {
  const { header } = useSelector(state => state.app);

  const isArquivaMix = Boolean(
    header?.accessGroupAll?.groupName === USER_SERVICES_LABELS.ARQUIVA_MIX,
  );

  return { isArquivaMix };
};
